import { AppProviders } from 'projects/legacyClient/src/appProviders';
import { CareResourcesHealthCard } from '@embark/shared-components/src/pet/careResources/health/careResourcesHealthCard';
import { ContentfulApolloClientProvider } from '@embark/shared-components/src/providers/contentfulApolloClientProvider';
import { FC } from 'react';
import ReactDOM from 'react-dom';
import { getPetNumFromQueryString } from 'projects/legacyClient/src/react/pet/getPetNumFromQueryString';
import { handleGraphQLError } from '@embark/shared-components/src/services/errors/handleGraphQLError';
import { useGetCareResourcesHealthCardDataQuery } from '@embark/shared-components/src/generated/graphql-client-types';

export function initCareResourcesHealthCard(): void {
  ReactDOM.render(
    <AppProviders>
      <CareResourcesHealthCardContainer />
    </AppProviders>,
    document.getElementById('careResourcesHealthCard')
  );
}

const CareResourcesHealthCardContainer: FC = () => {
  // NOTE: This assumes this component will appear on the /members/results/condition/171000?i=4 path
  const petNum = getPetNumFromQueryString();
  const conditionId = location.pathname.split('/')[4];

  const { data, loading, error } = useGetCareResourcesHealthCardDataQuery({
    variables: {
      petNum,
    },
  });

  if (error) {
    handleGraphQLError(error);
    return <></>;
  }

  if (loading || !data) {
    return <></>;
  }

  if (!data.me || !data.me.petByPetNum) {
    return <></>;
  }

  const pet = data.me.petByPetNum;

  if (!pet.shouldShowCareResources) {
    return <></>;
  }

  return (
    <ContentfulApolloClientProvider>
      <CareResourcesHealthCard pet={pet} conditionId={conditionId} />
    </ContentfulApolloClientProvider>
  );
};
